import React, { useEffect, useState } from "react";
import "./ProfileDetails.scss";
import close from "../../asset/recommendation/close.svg";
import star from "../../asset/recommendation/star.svg";
import download from "../../asset/recommendation/download.svg";
import file from "../../asset/recommendation/file.svg";
import { removeProfile } from "../../redux/userReducer";
import { useDispatch, useSelector } from "react-redux";
import graphqlRequest from "../../requestMethod";
import { message } from "../Common/SnakeAlert/SnakeAlert";
import Avtar from "../../asset/avtar.png";
import { CircularProgress } from "@mui/material";
import badge from "../../asset/badge.svg";
import { getRandomNumber } from "./../Profile/RandomNumber";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { pushEvent } from "../../utils/clevertap";

// const getRandomNumber = () => Math.floor(Math.random() * (20 - 5 + 1)) + 5;
function ProfileDetails({
  setOpenProfileView,
  showProfileData,
  recommendedUserAbsolute,
}) {
  let dispatch = useDispatch();
  let { userJobPostDetails, userJobPostDetailsArray } = useSelector(
    (state) => state.user,
  );
  let [isResumeLoading, setResumeLoading] = useState(false);
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;

  const getFileExtension = (url) => {
    const parts = url.split(".");
    // console.log(">>>>>>>1>>>>>>>",parts)
    // const data1 = parts[parts.length - 1].split("?")[0];
    // console.log(">>>>>>>2>>>>>>>",data1)
    // return data1
    return parts[parts.length - 1].split("?")[0];
  };

  // const handleDownLoadResume = () => {
  //   setResumeLoading(true);
  //   const query = `{
  //         withAuth(token:"${token}"){
  //          getUserPdf(id: "${showProfileData?.id}")
  //         }
  //       }`;
  //    graphqlRequest(query).then((response) => {
  //     if (response.data.withAuth.getUserPdf) {
  //       setResumeLoading(false);
  //       const data = response?.data?.withAuth?.getUserPdf;
  //       const linkSource = `data:application/pdf;base64,${data}`;
  //       let a = document.createElement("a");
  //       a.href = linkSource;
  //       // a.download = "resume.pdf";
  //       a.download = `${showProfileData.name.full}_resume.pdf`;
  //       a.click();
  //       message.success("Download Completed.");
  //     }else{
  //       setResumeLoading(false);
  //       message.error("Currently we don't have File to Download.");
  //     }
  //     // else {
  //     //   const query = `{
  //     //     withAuth(token:"${token}"){
  //     //      getUser(id: "${showProfileData?.id}"){
  //     //       documents {
  //     //         docType {
  //     //           name
  //     //         }
  //     //         files {
  //     //           secureUrl
  //     //           uri
  //     //         }
  //     //       }
  //     //      }
  //     //     }
  //     //   }`;

  //     //   graphqlRequest(query).then((response) => {
  //     //     // console.log("46-->", response)
  //     //     if (response?.data?.withAuth?.getUser?.documents?.length >= 0) {
  //     //       setResumeLoading(false);
  //     //       const data = response.data.withAuth.getUser.documents.find((doc) => {
  //     //         return doc.docType?.name === "CV";
  //     //       });

  //     //       if (!data) {
  //     //         setResumeLoading(false);
  //     //         message.error("Professional CV Not Available");
  //     //       }

  //     //       const linkSource = data.files[0].uri;
  //     //       fetch(linkSource)
  //     //         .then((response) => response.blob())
  //     //         .then((blob) => {
  //     //           const filename = `${showProfileData.name.full}_resume.${getFileExtension(linkSource)}`;

  //     //           const url = window.URL.createObjectURL(blob);
  //     //           const a = document.createElement("a");
  //     //           a.href = url;
  //     //           a.download = filename;
  //     //           a.style.display = "none";
  //     //           document.body.appendChild(a);
  //     //           a.click();
  //     //           window.URL.revokeObjectURL(url);
  //     //         })
  //     //         .catch((error) => {
  //     //           console.error("Error downloading the file:", error);
  //     //         });
  //     //     } else {
  //     //       setResumeLoading(false);
  //     //       message.error("Currently we don't have File to Download.");
  //     //     }
  //     //   });
  //     // }
  //   });
  // };

  const handleDownLoadResume = () => {
    setResumeLoading(true);
    const query1 = `{
      withAuth(token:"${token}"){
        getUser(id: "${showProfileData?.id}"){
          documents {
            docType {
              name
            }
            files {
              secureUrl
              uri
              url
            }
          }
        }
      }
    }`;

    graphqlRequest(query1)
      .then((response) => {
        const documents = response?.data?.withAuth?.getUser?.documents || [];
        const data = documents.find((doc) => doc.docType?.name === "CV");

        if (data && data.files?.[0]?.url) {
          let linkSource = data.files[0].url;
          console.log("linkSource1", linkSource);
          if (linkSource.startsWith("http://")) {
            linkSource = linkSource.replace("http://", "https://");
          }
          console.log("linkSource2", linkSource);
          fetch(linkSource)
            .then((res) => res.blob())
            .then((blob) => {
              const filename = `${
                showProfileData.name.full
              }_resume.${getFileExtension(linkSource)}`;
              // console.log("hnadleResume,  here 1")
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              setResumeLoading(false);
            })
            .catch((error) => {
              console.error("Error downloading file:", error);
              setResumeLoading(false);
              message.error("Failed to download the file.");
            });
        } else {
          // fallback to getUserPdf
          const query2 = `{
            withAuth(token:"${token}"){
              getUserPdf(id: "${showProfileData?.id}")
            }
          }`;

          graphqlRequest(query2)
            .then((response) => {
              const data = response?.data?.withAuth?.getUserPdf;

              if (data) {
                const linkSource = `data:application/pdf;base64,${data}`;
                // console.log("hnadleResume,  here 2");
                const a = document.createElement("a");
                a.href = linkSource;
                a.download = `${showProfileData.name.full}_resume.pdf`;
                a.click();
                message.success("Download Completed.");
              } else {
                message.error("Currently we don't have File to Download.");
              }
              setResumeLoading(false);
            })
            .catch((error) => {
              console.error("Error fetching fallback PDF:", error);
              setResumeLoading(false);
              message.error("Failed to fetch the fallback resume.");
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setResumeLoading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  //this is based on old logic
  // const handleViewResume = () => {
  //   setResumeLoading(true);
  //   const query1 = `{
  //     withAuth(token:"${token}"){
  //       getUser(id: "${showProfileData?.id}"){
  //         documents {
  //           docType {
  //             name
  //           }
  //           files {
  //             secureUrl
  //             uri
  //             url
  //           }
  //         }
  //         professionalResume{
  //           manualResumeUrl
  //           AIResumeUrl
  //           resumeStatus
  //         }
  //       }
  //     }
  //   }`;

  //   graphqlRequest(query1)
  //     .then((response) => {
  //       const documents = response?.data?.withAuth?.getUser?.documents || [];
  //       const data = documents.find((doc) => doc.docType?.name === "CV");

  //       if (data && data.files?.[0]?.url) {
  //         let linkSource = data.files[0].url;

  //         // Ensure we're using HTTPS
  //         if (linkSource.startsWith("http://")) {
  //           linkSource = linkSource.replace("http://", "https://");
  //         }

  //         // Check if iOS device
  //         const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  //                      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  //         if (isIOS) {
  //           // For iOS, create a temporary anchor element and trigger a click
  //           const link = document.createElement('a');
  //           link.href = linkSource;
  //           link.target = '_blank';
  //           link.rel = 'noopener noreferrer';

  //           // Add to document, trigger click, and remove
  //           document.body.appendChild(link);
  //           link.click();
  //           document.body.removeChild(link);
  //         } else {
  //           // For other devices, use the existing PDF viewer approach
  //           const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(linkSource)}`;
  //           const newWindow = window.open('', '_blank');
  //           if (newWindow) {
  //             newWindow.location.href = viewerUrl;
  //           } else {
  //             // If popup is blocked, fall back to direct link
  //             window.location.href = linkSource;
  //           }
  //         }
  //       } else {
  //         throw new Error("No resume found to display.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching resume:", error);
  //       message.error("Failed to fetch the resume.");
  //     })
  //     .finally(() => {
  //       setResumeLoading(false);
  //     });
  // };

  const handleViewResume = () => {
    setResumeLoading(true);

    const query1 = `{
    withAuth(token:"${token}"){
      getUser(id: "${showProfileData?.id}"){
        documents {
          docType {
            name
          }
          files {
            secureUrl
            uri
            url
          }
        }
        professionalResume {
          manualResumeUrl
          AIResumeUrl
          resumeStatus
        }
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const user = response?.data?.withAuth?.getUser;

        const documents = user?.documents || [];
        const professionalResume = user?.professionalResume || [];

        let linkSource = null;

        // --------------------------------------------------
        // 1. Check professionalResume first
        // --------------------------------------------------
        if (professionalResume.length > 0) {
          const activeResume = professionalResume.find(
            (resume) => resume?.resumeStatus === true,
          );

          if (activeResume) {
            // Prefer AI resume if available, otherwise manual resume
            linkSource =
              activeResume?.AIResumeUrl ||
              activeResume?.manualResumeUrl ||
              null;
          }
        }

        // --------------------------------------------------
        // 2. Fallback to CV document if no active resume found
        // --------------------------------------------------
        if (!linkSource) {
          const cvDocument = documents.find(
            (doc) => doc?.docType?.name === "CV",
          );

          if (cvDocument?.files?.[0]?.url) {
            linkSource = cvDocument.files[0].url;
          }
        }

        // --------------------------------------------------
        // 3. No resume found
        // --------------------------------------------------
        if (!linkSource) {
          throw new Error("No resume found to display.");
        }

        // --------------------------------------------------
        // 4. Ensure HTTPS
        // --------------------------------------------------
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        // --------------------------------------------------
        // 5. Check if iOS device
        // --------------------------------------------------
        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

        if (isIOS) {
          // For iOS, open the PDF directly
          const link = document.createElement("a");
          link.href = linkSource;
          link.target = "_blank";
          link.rel = "noopener noreferrer";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // For other devices, use existing PDF viewer
          const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
            linkSource,
          )}`;

          const newWindow = window.open("", "_blank");

          if (newWindow) {
            newWindow.location.href = viewerUrl;
          } else {
            // Popup blocked - fallback to direct URL
            window.location.href = linkSource;
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching resume:", error);
        message.error("Failed to fetch the resume.");
      })
      .finally(() => {
        setResumeLoading(false);
      });
  };
  let [invitedUser1, setInvitedUser1] = useState({});

  const jobId = userJobPostDetailsArray.map((j) => j.job.id);
  const jobIdString = `[${jobId.map((id) => `"${id}"`).join(",")}]`;

  // console.log("jobId", jobId);
  // console.log("jobIdString", jobIdString);

  let handlejobInvite = () => {
    let query = `
      query{
        withAuth(token:"${token}"){
          inviteUser(jobId:"${userJobPostDetails?.id}",userId:"${showProfileData?.id}")
        }
      }
      `;
    graphqlRequest(query).then((response) => {
      // console.log("invite-response", response)
      if (response?.errors) {
        message?.error("Already invited!");
      }
      if (response?.data?.withAuth?.inviteUser) {
        // console.log("inviteUser", response?.data?.withAuth?.inviteUser)
        // message?.success("Email has been sent");
        message?.success("Successfully Invited");
        // invitedUser.push({
        //   [showProfileData.id]: true,
        // });

        setInvitedUser1((invitedUser1) => ({
          ...invitedUser1,
          [showProfileData.id]: true,
        }));
      }
    });
  };

  let handleMultipleJobInvite = () => {
    let query = `
      query{
        withAuth(token:"${token}"){
          inviteUserToMultipleJobs(jobIds: ${jobIdString},userId:"${showProfileData?.id}")
        }
      }
      `;
    graphqlRequest(query).then((response) => {
      // console.log("invite-response", response)
      if (response?.errors) {
        message?.error("Already invited!");
      }
      if (response?.data?.withAuth?.inviteUserToMultipleJobs) {
        // console.log("inviteUser", response?.data?.withAuth?.inviteUser)
        // message?.success("Email has been sent");
        message?.success("Successfully Invited");
        pushEvent("Web_Invite_Apply_Job", {
          page: "Open Job",
          section: "Jobs",
          jobId: userJobPostDetails.id,
          ...showProfileData,
        });
        // invitedUser.push({
        //   [showProfileData.id]: true,
        // });

        setInvitedUser1((invitedUser1) => ({
          ...invitedUser1,
          [showProfileData.id]: true,
        }));
      }
    });
  };

  let valueToBeMatched;

  // console.log("invitedUser1", invitedUser1)

  let keyToBeMatched = `${showProfileData.id}` in invitedUser1;

  useEffect(() => {
    for (var i = 0; i <= invitedUser1.length; i++) {
      for (var key in invitedUser1[i]) {
        // console.log(invitedUser1[i][key], "abbe o");
        valueToBeMatched = invitedUser1[i][key];
      }
    }
  }, [invitedUser1]);

  const randomNumber = getRandomNumber();

  // console.log("recommendedUserAbsolute", recommendedUserAbsolute);
  console.log("showProfileData", showProfileData);

  const isAbsoluteProfile = recommendedUserAbsolute?.some(
    (abs) => abs.id === showProfileData.id,
  );
  const isSimilarProfile = !isAbsoluteProfile;

  return (
    <div className="profile-details-wrapper">
      <div className="profile-details-container">
        <div className="pd-one">
          <div className="close-profile">
            <img
              src={close}
              onClick={() => {
                setOpenProfileView(false);
                dispatch(removeProfile());
              }}
              alt="close"
            />
          </div>
          {/* <div className="flag-tape">
            {isAbsoluteProfile && "Recommended"}
            {isAbsoluteProfile && isSimilarProfile && " & "}
            {isSimilarProfile && "Similar Profile"}
          </div> */}
          <div className="user-profile-img">
            {showProfileData?.marksPercentage >= 60 && (
              <div
                className="dp-badge-hover"
                data-message="Jobizo Assessment Qualified"
              >
                <img src={badge} className="dp-badge" />
              </div>
            )}
            <img
              src={showProfileData?.avatar?.url || Avtar}
              className={
                showProfileData?.marksPercentage >= 60 ? "badge-border" : ""
              }
            />
            {/* <img src={showProfileData?.avatar?.url || Avtar} /> */}
          </div>
          <div className="user-profile-invite">
            <div className="up-top">
              <p>{showProfileData?.name?.full}</p>
              <span>{showProfileData?.professionalType?.name}</span>
            </div>
            <div className="up-bottom">
              <div>
                {/* {showProfileData.numberOfRatings >= 5 ? (
                      <>
                      {new Array(showProfileData.averageRating)
                        .fill(1)
                        .map((_, index) => (
                          // <img key={index} src={star} alt="star" />
                          <React.Fragment key={index}>
                            <img src={star} alt="star" />
                            {index === showProfileData.averageRating - 1 && (
                              <span
                                style={{
                                  position: 'relative', 
                                  top: '-3px', 
                                  left: '5px',
                                  fontSize: "0.9em",
                                }}
                              >
                                ({showProfileData.numberOfRatings})
                              </span>
                            )}
                          </React.Fragment>
                        ))}
                      {/* <span>({data.numberOfRatings})</span> */}
                {/* </>
                    ) : (
                      new Array(showProfileData.rating)
                        .fill(1)
                        .map((_, index) => (
                          <img key={index} src={star} alt="star" />
                        ))
                    )}  */}

                {showProfileData?.numberOfRatings >= 5 ? (
                  <>
                    {typeof showProfileData.averageRating === "number" &&
                    showProfileData.averageRating >= 0 ? (
                      new Array(Math.round(showProfileData.averageRating))
                        .fill(1)
                        .map((_, index) => (
                          <React.Fragment key={index}>
                            <img src={star} alt="star" />
                            {index ===
                              Math.round(showProfileData.averageRating) - 1 && (
                              <span
                                style={{
                                  position: "relative",
                                  top: "-3px",
                                  left: "5px",
                                  fontSize: "0.8em",
                                }}
                              >
                                ({showProfileData.numberOfRatings})
                              </span>
                            )}
                          </React.Fragment>
                        ))
                    ) : (
                      <span>Invalid average rating</span>
                    )}
                  </>
                ) : (
                  <>
                    {typeof showProfileData?.rating === "number" &&
                    showProfileData?.rating >= 0 &&
                    Number.isInteger(showProfileData?.rating) ? (
                      // new Array(showProfileData?.rating).fill(0).map(() => {
                      //   return <img src={star} alt="star" />;
                      // })
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                        }}
                      >
                        {new Array(showProfileData?.rating)
                          .fill(1)
                          .map((_, index) => (
                            <img key={index} src={star} alt="star" />
                          ))}
                        <span
                          style={{
                            position: "absolute",
                            top: "40%",
                            left: "calc(100% + 2px)",
                            transform: "translateY(-50%)",
                            fontSize: "0.8em",
                          }}
                        >
                          ({randomNumber + showProfileData?.rating})
                        </span>
                      </div>
                    ) : (
                      <span>Invalid rating</span>
                    )}
                  </>
                )}
              </div>
              {keyToBeMatched === true ? (
                <button className="disabled-button">Invited</button>
              ) : (
                <button onClick={handleMultipleJobInvite}>
                  Invite To Apply
                </button>
              )}
            </div>
          </div>
        </div>
        <hr className="hr-line" />
        <div className="pd-two">
          <div className="pd-left">
            <p>Department</p>
            <p>Specialization</p>
            <p>Experience</p>
            {/* <p>Gender</p> */}
            <p>Location</p>
          </div>
          <div className="pd-right">
            <p>{showProfileData?.departments?.[0]?.name}</p>
            <p>{showProfileData?.specialization?.name}</p>
            <p>{showProfileData?.numExperience?.name}</p>
            {/* <p className="email">{showProfileData?.profile?.gender}</p> */}
            <p>{showProfileData?.workCity?.name}</p>
          </div>
        </div>
        <hr className="hr-line" />
        <div className="pd-three">
          <div>
            <div>
              <img src={file} alt="file" />
              <div>
                <p className="file-name">View Resume</p>
                {/* <p className="file-name">Resume</p> */}
                {/* <p className="file-size">1.25MB</p> */}
              </div>
            </div>
            {isResumeLoading ? (
              <CircularProgress style={{ width: "30px", height: "30px" }} />
            ) : (
              <VisibilityIcon
                style={{ cursor: "pointer", fontSize: "30px" }}
                onClick={handleViewResume}
              />
              // <img
              //   src={download}
              //   alt="download"
              //   style={{ cursor: "pointer" }}
              //   // onClick={handleDownLoadResume}
              //   onClick={handleViewResume}
              // />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileDetails;

// {new Array(showProfileData.rating).fill(0).map(() => {
//   return <img src={star} alt="star" />;
// })}
